import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TokenInterceptor} from '@app/core/security/token.interceptor';
import {AnnouncementService} from '@app/views/common/dialog-announcement/announcement.service';
import {AnnouncementUploadService} from '@app/views/admin/application-settings/announcement-upload.service';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';
import {AuthenticationService} from '@app/core/service/authentication.service';
import {AuthGuard} from '@app/core/security/auth.guard';
import {AppGalleryService} from '@app/views/admin/provider/app-gallery/app-gallery.service';
import {ApplicationSettingsService} from '@app/views/admin/application-settings/application-settings.service';
import {ApplicationsService} from '@app/views/admin/provider/applications/applications.service';
import {CustomerService} from '@app/core/service/customer.service';
import {DataBrowsingService} from '@app/views/databrowsing/databrowsing.service';
import {DelegatedPermissionsService} from '@app/views/sso/delegated-permissions/delegated-permissions.service';
import {EmailNotificationsService} from '@app/core/service/email-notifications.service';
import {FiltersListService} from '@app/views/admin/application-settings/components/filters/filters-list-wrapper/filters-list.service';
import {GlobalService} from '@app/core/service/global.service';
import {InstitutionsService} from '@app/views/admin/vendor/institutions/institutions.service';
import {IntegrationService} from '@app/core/service/integration.service';
import {InteractiveGuideService} from '@app/core/service/interactive-guide.service';
import {LandingGuard} from '@app/core/security/landing.guard';
import {MatchMedia} from '@app/core/service/match-media.service';
import {NavbarService} from '@app/core/comp/navigation/navbar.service';
import {NgcSearchService} from '@app/views/search/search.service';
import {OrgsService} from '@app/core/service/orgs.service';
import {OneEdtechService} from '@app/views/admin/1edtech/one-edtech.service';
import {PrivacyPolicyService} from '@app/views/admin/privacy-policy/privacy-policy.service';
import {ProjectsDashboardService} from '@app/views/dashboard/projects.service';
import {SchemaListService} from '@app/views/admin/sysadm/schema-list/schemalist.service';
import {SignificantChangesService} from '@app/core/service/significant-changes.service';
import {SnackBarService} from '@app/core/service/snack-bar.service';
import {SpinnerService} from '@app/core/service/spinner.service';
import {SplashScreenService} from '@app/core/service/splash-screen.service';
import {ThemeService} from '@app/core/service/theme.service';
import {UserActivityService} from '../global/user-activity.service';
import {TokenService} from '@app/core/security/token.service';
import {UserHelpService} from '@app/core/service/user-help.service';
import {UserPreferencesService} from '@app/core/service/user-preferences.service';
import {DataBrowser} from '@app/views/databrowsing/data-browser';
import {FeatureTogglesService} from '@app/core/service/feature-toggles.service';
import {OidcSecurityProxyService} from '@app/core/service/oidc.security.proxy.service';
import {SSOPortalService} from '@app/views/sso/sso-portal.service';
import {AuditUserActivityService} from '@app/core/service/audit-user-activity.service';
import {PIIShieldService} from '@app/core/service/pii-shield.service';
import {MixpanelService} from '@app/core/service/mixpanel.service';



@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        HttpClientModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        AnnouncementService,
        AnnouncementUploadService,
        AuthenticatedUserService,
        AuthenticationService,
        AuthGuard,
        AppGalleryService,
        ApplicationSettingsService,
        ApplicationsService,
        CustomerService,
        DataBrowser,
        DataBrowsingService,
        DecimalPipe,
        DelegatedPermissionsService,
        EmailNotificationsService,
        FiltersListService,
        GlobalService,
        InstitutionsService,
        IntegrationService,
        InteractiveGuideService,
        LandingGuard,
        MatchMedia,
        NavbarService,
        NgcSearchService,
        OrgsService,
        OneEdtechService,
        PIIShieldService,
        PrivacyPolicyService,
        ProjectsDashboardService,
        SchemaListService,
        SignificantChangesService,
        SnackBarService,
        SpinnerService,
        SplashScreenService,
        ThemeService,
        TokenService,
        UserActivityService,
        UserHelpService,
        UserPreferencesService,
        FeatureTogglesService,
        OidcSecurityProxyService,
        SSOPortalService,
        AuditUserActivityService,
        MixpanelService
    ]
})
export class ServiceModule { }
